import { EventColumnEnum } from "../../enums/DRCXEnums";
import { makeEventColumnEquatableKey } from "../../utilities/drcx/MakeEventColumnEquatableKey";
import { DRCXAvailableObjectBase } from "./DRCXAvailableObjectBase";

export class DRCXAvailableEventColumn extends DRCXAvailableObjectBase<string> {
    public constructor(displayText: string,
        public eventColumn: EventColumnEnum,
        public readOnly: boolean
    ) {
        super(displayText, makeEventColumnEquatableKey(eventColumn))
    }
}
